import { render, staticRenderFns } from "./IncreaseNumber.vue?vue&type=template&id=a6dd790e&"
import script from "./IncreaseNumber.vue?vue&type=script&lang=js&"
export * from "./IncreaseNumber.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a6dd790e')) {
      api.createRecord('a6dd790e', component.options)
    } else {
      api.reload('a6dd790e', component.options)
    }
    module.hot.accept("./IncreaseNumber.vue?vue&type=template&id=a6dd790e&", function () {
      api.rerender('a6dd790e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-8435DR4Gbw8yL/JS/comp/IncreaseNumber.vue"
export default component.exports